<template>
    <svg :class="svgClass" :style="svgStyle" :width="width" :height="height" :viewBox="viewBox" aria-hidden="true" @click="handleClick">
        <use :xlink:href="iconName"></use>
    </svg>
</template>

<script>
import { calcCssUnit } from '@/utils/calcCssUnit.js'
export default {
    name: 'svg-icon',
    props: {
        // 图标名称
        iconClass: {
            type: String,
            required: true,
        },
        // 自定义样式类
        className: {
            type: String,
            default: '',
        },
        // 图标尺寸
        size: {
            type: [String, Number],
            default: '1em',
        },
        // 宽度
        width: {
            type: [String, Number],
            default: '',
        },
        // 高度
        height: {
            type: [String, Number],
            default: '',
        },
        // 填充颜色
        fill: {
            type: String,
            default: '',
        },
        // 描边颜色
        stroke: {
            type: String,
            default: '',
        },
        // 描边宽度
        strokeWidth: {
            type: [String, Number],
            default: '',
        },
        // 视图框
        viewBox: {
            type: String,
            default: '0 0 24 24',
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        // 图标名称 - 使用svg-sprite-loader的symbolId格式
        iconName() {
            return `#icon-${this.iconClass}`
        },
        // SVG类名
        svgClass() {
            const baseClass = 'svg-icon'
            const classes = [baseClass]

            if (this.className) {
                classes.push(this.className)
            }

            if (this.disabled) {
                classes.push('svg-icon--disabled')
            }

            return classes.join(' ')
        },
        // SVG样式
        svgStyle() {
            const style = {}

            // 处理尺寸
            if (this.width || this.height) {
                if (this.width) {
                    style.width = this.convertToRem(this.width)
                }
                if (this.height) {
                    style.height = this.convertToRem(this.height)
                }
            } else if (this.size) {
                const sizeValue = this.convertToRem(this.size)
                style.width = sizeValue
                style.height = sizeValue
            }

            // 设置填充色
            if (this.fill) {
                style.fill = this.fill
            }

            // 设置描边
            if (this.stroke) {
                style.stroke = this.stroke
            }
            if (this.strokeWidth) {
                style.strokeWidth = this.strokeWidth
            }

            return style
        },
    },
    methods: {
        /**
         * 转换单位
         * @param {string|number} value - 要转换的值
         * @returns {string} 转换后的值
         */
        convertUnit(value) {
            if (typeof value === 'number') {
                return `${value}px`
            }
            if (typeof value === 'string') {
                // 如果已经是CSS单位，直接返回
                if (/rem|em|px|%|vw|vh/i.test(value)) {
                    return value
                }
                // 尝试转换为数字
                const num = parseFloat(value)
                if (!isNaN(num)) {
                    return `${num}px`
                }
                return value
            }
            return value
        },

        /**
         * 将值转换为 rem 单位
         * @param {string|number} value - 要转换的值
         * @returns {string} rem 值字符串
         */
        convertToRem(value) {
            if (typeof value === 'number') {
                return calcCssUnit(value)
            } else if (typeof value === 'string') {
                if (value.includes('rem') || value.includes('em') || value.includes('px') || value.includes('%')) {
                    return value
                }
                const numValue = parseFloat(value)
                if (!isNaN(numValue)) {
                    return calcCssUnit(numValue)
                }
                return value
            }
            return value
        },
        /**
         * 处理点击事件
         * @param {Event} event - 点击事件
         */
        handleClick(event) {
            if (this.disabled) {
                return
            }
            this.$emit('click', event)
        },
    },
}
</script>

<style scoped>
.svg-icon {
    display: inline-block;
    overflow: hidden;
    vertical-align: -0.15em;
    fill: currentColor;
    transition: all 0.2s ease;
    cursor: pointer;
}

.svg-icon:hover {
    opacity: 0.8;
}

.svg-icon--disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.svg-icon--disabled:hover {
    opacity: 0.5;
}
</style>
